import { SwiperSlide } from "swiper/react";
import Carousel from "../../carousel/carousel.component";
import { IMAGE_TYPE } from "../../image/image.component";
import YoutubeEmbed from "../../youtube-embed/youtube-embed.component";
import { CMImage } from "./auction-carousel.styles";

export const imgBreakpoints = {
    1: {
      slidesPerView: 1,
      spaceBetween: 8
    }
}

export const AUCTION_CAROUSEL_TYPE = {
    imageSemiRounded: 'images-semi-rounded',
    imageRounded: 'images-rounded',
    video: 'video'
}

const AuctionCarousel = ({slides, carouselType, breakpoints, height, auctionID}) => {
    return (
        <Carousel breakpoints={breakpoints || undefined} navigation={false}>
            {slides && slides.length > 0 ? 
                slides.map((slide, index) => {
                    if(carouselType !== AUCTION_CAROUSEL_TYPE.video || index < 3 ) {
                        return (
                            <SwiperSlide key={index}>
                                {
                                    {
                                        [AUCTION_CAROUSEL_TYPE.imageSemiRounded]: <CMImage src={slide} imageType={IMAGE_TYPE.semi}/>,
                                        [AUCTION_CAROUSEL_TYPE.imageRounded]: <CMImage src={slide} imageType={IMAGE_TYPE.rounded}/>,
                                        [AUCTION_CAROUSEL_TYPE.video]: <YoutubeEmbed source={slide.link || ''} thumbnail={slide.thumbnail} height={height || 100} auctionID={auctionID} />
                                    }[carouselType]
                                }
                            </SwiperSlide>
                        );
                    }
                }) : ''
            }
        </Carousel>
    );
}

export default AuctionCarousel;